export function extractUrl(input: string): string | null {
  const regex = /^Url\('(.*)'\)$/;
  const match = input.match(regex);
  return match ? match[1] : null;
}

export function isUrlString(input: string): boolean {
  const regex = /^Url\('https?:\/\/[^\s']+'\)$/;
  return regex.test(input);
}

export function isValidUrl(input: string): boolean {
  const validUrlRegex = new RegExp(
    '^(https?:\\/\\/)' + // protocol
      '((([a-zA-Z\\d]([a-zA-Z\\d-]*[a-zA-Z\\d])*)\\.)+[a-zA-Z]{2,}|' + // domain
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR IP (v4)
      '(\\:(?:[1-9]\\d{0,3}|[1-5]\\d{4}|6[0-4]\\d{3}|65[0-4]\\d{2}|655[0-2]\\d|6553[0-5]))?' + // port
      '(\\/[-a-zA-Z\\d%_.~+@() ]*)*' + // path
      '(\\?[^\\s#]*)?' + // query
      '(\\#\\S*)?$',
    'i'
  );
  return validUrlRegex.test(input);
}

export function objectToQueryParams(obj) {
  let queryString = '';
  Object.keys(obj ?? {}).forEach(key => {
    if (queryString !== '') {
      queryString += `&${key}=${obj[key]}`;
    } else {
      queryString += `${key}=${obj[key]}`;
    }
  });
  return queryString;
}
